import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'queryImageByUrl'
})
export class QueryImageByUrlPipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  transform(url:string): Observable<SafeUrl> {
      return this.http.get(url, { responseType: 'blob' }).pipe(
      map(val => {
        return  this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))
        // const a = URL.createObjectURL(val)
        // console.log(a)
        // return a
        })
    )
}

}
